import React from 'react';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  Space,
  Table,
  Typography,
} from 'antd';
import { SearchOutlined, SelectOutlined } from '@ant-design/icons';
import { PatternCodeType } from 'components/Admin/PatternCode';
import {
  //Label,
  Loading,
  ScreenMask,
  SetDefaultWarehouseDialog,
  //SuccessButton,
  message,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  LOADING_ICON_SIZE1,
  LS_DEFAULT_WAREHOUSE_KEY,
} from 'constants/config';
import { RootState } from 'reducers';
import { fetchWarehouseProductList2 } from 'services/inventory';
import { adjustAuditItem } from 'services/product';
import { queryLocationsByKeyword } from 'services/warehouse';
import { getWarehouseCodeFromCache, playSound, } from 'utils';
import {
  extractPatternCodeList,
  getMatchedPatternCode,
  isAnyPatternMatched,
  isPatternCodeEnabled,
} from '../../PoReceive';
import {
  GreenColor,
  SmartBackButton,
  SmartButton,
  SmartFormLabel,
  SmartNumberInput,
  SmartRow,
  SmartScanner,
  SmartScannerInput,
  SmartSpace,
} from '../../SmartComponent';
import {
  PoRecvActionType as PRAction,
  defaultUom,
  initialState,
  reducer,
} from '../../MoveMerge/GuidedMove2/context';
import PatternCodeSelector from '../../PoReceive/PatternCodeSelector';
import SearchLotDrawer from '../../PoReceive/SearchLotDrawer';
import UomSelector, { checkoutUomBySkuAndCode } from '../../PoReceive/UomSelector';

enum AdjustStep {
  ScanItem,
  ScanLocation,
  ConfirmToSubmit,
};

const getStateFromStorage = () => {
  const state: StringKAnyVPair = {};
  //const storage = getStorage('session');

  /*
  const scanRecvCountType = storage.getItem(PoRecvStorageKey.ScanRecvCountType);
  if (scanRecvCountType !== null && !isNaN(Number(scanRecvCountType))) state.scanRecvCountType = Number(scanRecvCountType);
  const scanRecvLotPolicy = storage.getItem(PoRecvStorageKey.ScanRecvLotPolicy);
  if (scanRecvLotPolicy !== null && !isNaN(Number(scanRecvLotPolicy))) state.scanRecvLotPolicy = Number(scanRecvLotPolicy);
  const scanRecvLotUniNum = storage.getItem(PoRecvStorageKey.ScanRecvLotUniNum);
  if (scanRecvLotUniNum !== null) state.scanRecvLotUniNum = scanRecvLotUniNum;
  const scanRecvRatio = storage.getItem(PoRecvStorageKey.ScanRecvRatio);
  if (scanRecvRatio !== null && !isNaN(Number(scanRecvRatio))) state.scanRecvRatio = Number(scanRecvRatio);
  const scanRecvRatioType = storage.getItem(PoRecvStorageKey.ScanRecvRatioType);
  if (scanRecvRatioType !== null && !isNaN(Number(scanRecvRatioType))) state.scanRecvRatioType = Number(scanRecvRatioType);
  */

  return state;
};

const GuidedAdjust = () => {
  const { Text } = Typography;
  const { useReducer, useState } = React;
  const [adjustLotCode, setAdjustLotCode] = useState('');
  const [adjustQty, setAdjustQty] = useState<number>();
  const [currentStep, setCurrentStep] = useState<AdjustStep>();
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] = useState(false);
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [enableAddNewLocation, setEnableAddNewLocation] = useState(false);
  const [inited, setInited] = useState(false);
  const [isSearchLotDrawerOpen, setIsSearchLotDrawerOpen] = useState(false);
  const [itemCodeScannerVersion, setItemCodeScannerVersion] = useState(0);
  const [lotScannerVersion, setLotScannerVersion] = useState(0);
  //const [lotEnable, setLotEnable] = useState(false);
  const [patternCodeSelectorVisible, setPatternCodeSelectorVisible] = useState(false);
  const [productLocations, setProductLocations] = useState<StringKAnyVPair[]>([]);
  const [profileSettingInited, setProfileSettingInited] = useState(false);
  const [targetLocation, setTargetLocation] = useState<StringKAnyVPair>({});
  //const [uomEnable, setUomEnable] = useState(false);
  const [uomSelectorVisible, setUomSelectorVisible] = useState(false);

  const history = useHistory();
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(reducer, initialState(getStateFromStorage()));

  const userProfileSettings = useSelector(
    (state: RootState) => state.admin.userProfileSettings,
    shallowEqual
  );
  const warehouseList = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );

  const columns: StringKAnyVPair[] = [
    {
      title: 'LOC#',
      dataIndex: 'locationCode',
      key: 'locationCode',
    },
    {
      title: 'LOT#',
      dataIndex: 'lotNumber',
      key: 'lotNumber',
    },
    {
      title: 'UOM',
      dataIndex: 'uom',
      key: 'uom',
    },
    {
      title: 'Rate',
      dataIndex: 'uomRate',
      key: 'uomRate',
    },
    {
      title: 'Base Qty',
      dataIndex: 'uomBaseQty',
      key: 'uomBaseQty',
    },
  ];

  const adjustProduct = async () => {
    const prd = productLocations[0];
    const pd: StringKAnyVPair = {
      fulfillmentProductNum: prd.fulfillmentProductNum,
      locationCode: targetLocation.locationCode,
      //locationNum: targetLocation.locationNum,
      quantity: adjustQty,
      reason: null,
    };

    if (state.enableUom) {
      pd.uom = state.uomInfo.uom;
      pd.uomRate = state.uomInfo.uomRate;
    }

    state.enableLot && (pd.lotNumber = adjustLotCode);
    //console.log('se', state.enableLot, pd, adjustLotCode);
    //console.log('pd', pd, state.selectedWarehouse.warehouseId);
    dispatch({ type: PRAction.SetLockScreen, params: true });
    try {
      const res = await adjustAuditItem(state.selectedWarehouse.warehouseId, pd);
      console.log('r', res);
      if (res) {
        message.success({
          content: 'Adjusted successfully',
          duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
        });
        startNewAdjustment();
      }
    } catch(e) {
      message.error({
        content: `Adjusted error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false }); 
    }
  };

  const closePatternCodeSelector = () => {
    setPatternCodeSelectorVisible(false);
  };

  const closeSearchLotDrawer = () => {
    setIsSearchLotDrawerOpen(false);
  };

  const closeUomSelector = () => {
    setUomSelectorVisible(false);
  };

  const getColumns = () => {
    let temp = [ ...columns ];

    //temp = lotEnable ? temp : temp.filter((i) => i.dataIndex !== 'lotNumber');
    temp = state.enableLot ? temp : temp.filter((i) => i.dataIndex !== 'lotNumber');
    //temp = uomEnable
    temp = state.enableUom
      ? temp
      : temp.filter((i) => ['uom', 'uomRate'].indexOf(i.dataIndex) === -1);

    return temp;
  };

  const isAdjustable = () => {
    return adjustQty && adjustQty > 0;
  };

  // eslint-disable-next-line
  const isLocationItemUsable = (item: StringKAnyVPair, checkQty = true) => {
    let ret = true;

    if (isPatternCodeEnabled(state)) {
      const lot =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT) || '';
      const uom =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM) || defaultUom.uom;
      const qty =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty);
      //let match = checkSourceLocation ? item.locationCode === sLocation?.locationCode : true;
      let match = true;

      //match && (match = lotEnable ? item.lotNumber === lot : true);
      match && (match = state.enableLot ? item.lotNumber === lot : true);
      //match && (match = uomEnable ? item.uom === uom : true);
      match && (match = state.enableUom ? item.uom === uom : true);
      (match && checkQty) && (match = item.uomBaseQty >= qty);
      ret = match;
    }

    return ret;
  };

  const isLotReleased = () => {
    return true;
  };

  const isPatternCodeIncludeLot = () => {
    let ret = false;

    if (isPatternCodeEnabled(state)) {
      const lot = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);

      //ret = !!(lotEnable && lot);
      ret = !!(state.enableLot && lot);
    }

    return ret;
  };

  const isPatternCodeIncludeLotOrUomOrQty = () => {
    let ret = false;

    if (isPatternCodeEnabled(state)) {
      const lot = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
      const uom = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);
      const qty = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty);

      //ret = !!((lotEnable && lot) || (uomEnable && uom) || (!isNaN(Number(qty))));
      ret = !!((state.enableLot && lot) || (state.enableUom && uom) || (!isNaN(Number(qty))));
    }

    return ret;
  };

  const isPatternCodeIncludeQty = () => {
    let ret = false;

    if (isPatternCodeEnabled(state)) {
      const qty = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty);

      ret = !isNaN(Number(qty));
    }

    return ret;
  };

  const isPatternCodeIncludeUom = () => {
    let ret = false;

    if (isPatternCodeEnabled(state)) {
      const uom = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);

      //ret = !!(uomEnable && uom);
      ret = !!(state.enableUom && uom);
    }

    return ret;
  };

  const isUomEnabled = () => {
    return state.enableUom && (!state.isCheckingUom);
  };

  const onClearLotCode = () => {
    setAdjustLotCode('');
  };

  const onClosePatternCodeSelectorWithoutSelection = () => {
    //tryOpenDefaultLocationDialogWithoutPatternCode();
    setCurrentStep(AdjustStep.ScanItem);
  };

  const onAdjustQtyChange = (qty: any) => {
    //console.log('q', qty, typeof qty);
    setAdjustQty(qty);
  };

  const onItemCodeChange = async (pc: string) => {
    let sk = pc.trim();

    //console.log('patter code', pc);
    sk === '' && setItemCodeScannerVersion(itemCodeScannerVersion + 1);
    sk !== '' && playSound('bell');

    if (sk && isPatternCodeEnabled(state)) {
      const pl = extractPatternCodeList(state, sk);
      const patternMatched = isAnyPatternMatched(pl || []);

      if (pl && patternMatched) {
        const codeList: StringKAnyVPair[] = [];
        //const pQty = getMatchedPatternCode(pl, PatternCodeType.Qty);

        (pl || []).forEach(e => codeList.push(e));
        dispatch({ type: PRAction.SetMatchedPatternList, params: codeList });
        sk = getMatchedPatternCode(pl, PatternCodeType.SKU);
        //setItemCode(code);
        //(!isNaN(Number(pQty))) && setItemQty(pQty);
      }
    }

    if (sk) {
      dispatch({ type: PRAction.SetLockScreen, params: true }); 
      try {
        const params = {
          warehouseNum: state.selectedWarehouse.warehouseNum,
          uniqueCode: sk,
        };
        const res = await fetchWarehouseProductList2(params);

        if (Array.isArray(res)) {
          const pls = res.filter(e => e.locationCode !== 'Checkout');

          setProductLocations(sortLocationList(pls));

          if (pls.length > 0) {
            setCurrentStep(AdjustStep.ScanLocation);
          } else {
            message.info({
              content: 'No record found',
              duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
            });
          }
        }
      } catch(e) {
        message.error({
          content: `Fetched location list error: ${e}`,
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
      } finally {
        dispatch({ type: PRAction.SetLockScreen, params: false }); 
      }
    }
  };

  const onLocationCodeChange = async (sk: string) => {
    const lc = sk.trim();
    const loc = productLocations.find(l => l.locationCode.toLowerCase() === lc.toLowerCase());

    if (loc) {
      playSound('bell');
      dispatch({ type: PRAction.SetLockScreen, params: true }); 
      try {
        const res = await queryLocationsByKeyword(state.selectedWarehouse.warehouseId, lc, true);

        if (res && typeof res === 'object') {
          setTargetLocation(res);
          setConfirmForm();
          setCurrentStep(AdjustStep.ConfirmToSubmit);
        }
      } catch(e) {
        message.error({
          content: `Fetched location error: ${e}`,
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
      } finally {
        dispatch({ type: PRAction.SetLockScreen, params: false }); 
      }
    } else {
      if (enableAddNewLocation) {
        setTargetLocation({
          locationCode: lc,
          locationNum: 0,
        });
        setConfirmForm();
        setCurrentStep(AdjustStep.ConfirmToSubmit);
      } else {
        playSound('error');
        Modal.error({
          title: 'Error',
          content: (
            <SmartSpace>
              <span className="fs-16">You can’t insert SKU (<span className="text-green-label">{productLocations[0].sku}</span>) into Location (<span className="text-error">{lc}</span>)</span>
            </SmartSpace>
          ),
        });
      }
    }
  };

  const onPageBack = () => {
    //history.push('/smart/poreceive');
    switch (currentStep) {
      case AdjustStep.ScanLocation:
        setCurrentStep(AdjustStep.ScanItem);
        break;

      case AdjustStep.ConfirmToSubmit:
        setCurrentStep(AdjustStep.ScanLocation);
        break;
    
      default:
        history.goBack();
        break;
    }
  };

  const onScanLot = (lotStr: string) => {
    const lc = lotStr.trim();

    setAdjustLotCode(lc);
    playSound('bell');
  };

  const onSelectLot = (lot: StringKAnyVPair) => {
    //console.log('lot', lot);
    onScanLot(lot.lotNumber);
    setLotScannerVersion(lotScannerVersion + 1);
  };

  const onSelectPatternCode = (pat: StringKAnyVPair) => {
    //const location = (pat.items || []).find((p: StringKAnyVPair) => p.valueType === PatternCodeType.Location);
    //console.log('p', location);
    //!location && openDefaultLocationDialog();
    setCurrentStep(AdjustStep.ScanItem);
  };

  const onSelectUom = (uomInfo?: StringKAnyVPair) => {
    //console.log('uom', uomInfo);
    playSound('bell');
  };

  const openPatternCodeSelector = () => {
    setPatternCodeSelectorVisible(true);
  };

  const openSearchLotDrawer = () => {
    setIsSearchLotDrawerOpen(true);
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  const openUomSelector = () => {
    setUomSelectorVisible(true);
  };

  const searchLotButton = () => {
    return (
      <Button
        disabled={!isLotReleased()}
        onClick={openSearchLotDrawer}
        type="text"
      >
        <SearchOutlined />
      </Button>
    );
  };

  const setConfirmForm = () => {
    const sku = productLocations[0].sku;
    const lot =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
    const qty = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty);
    const uomCode =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM) || defaultUom.uom;

    setAdjustLotCode(lot);
    setAdjustQty(Number(qty) || undefined);
    checkoutUomBySkuAndCode(sku, uomCode, state, dispatch);
  };

  const sortLocationList = (list: StringKAnyVPair[]) => {
    const data = [...list];
    const gd: StringKAnyVPair = {};
    const gl: StringKAnyVPair[][] = [];
    let ret: StringKAnyVPair[] = [];

    data.forEach(e => {
      (!gd[e.locationCode]) && (gd[e.locationCode] = []);
      gd[e.locationCode].push(e);
    });

    for (const k in gd) gl.push(gd[k]);

    //gl.sort((a, b) => (a[0].locationCode === sLocation?.locationCode) ? -1 : 1);
    gl.sort((a, b) => a[0].locationNum - b[0].locationNum);
    gl.forEach(g => {
      g.sort((a, b) => {
        let cmp = 0;

        if (isPatternCodeEnabled(state)) {
          const lot =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
          //const uom =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);
          //const qty =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty);
          cmp = lot ? (a.lotNumber.localeCompare(lot) - b.lotNumber.localeCompare(lot)) : a.lotNumber.localeCompare(b.lotNumber);
          (cmp === 0) && (cmp = b.uomBaseQty - a.uomBaseQty);
        } else {
          cmp = a.lotNumber.localeCompare(b.lotNumber);
          (cmp === 0) && (cmp = b.uomBaseQty - a.uomBaseQty);
        }

        return cmp;
      });

      ret = [...ret, ...g];
    });
    //console.log('gl', gl);

    return ret;
  };

  const startNewAdjustment = () => {
    setCurrentStep(AdjustStep.ScanItem);
    setAdjustLotCode('');
    setAdjustQty(undefined);
    setProductLocations([]);
    dispatch({ type: PRAction.SetMatchedPatternList, params: [] });
  };

  React.useEffect(() => {
    if (!inited) {
      const whid = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (!whid || (typeof whid === 'number' && !getWarehouseCodeFromCache(whid))) {
        openSetDefaultWarehouseDialog({ closable: false });
      }

      const wh = warehouseList.find(w => w.id === whid);

      if (wh) {
        dispatch({ type: PRAction.SetSelectedWarehouse, params: {...wh} });
      }

      //gotoAnchor(PoRecvStep.ScanPo);
      setInited(true);
    }

    if (userProfileSettings === null && !state.lockScreen) dispatch({ type: PRAction.SetLockScreen, params: true });

    if (userProfileSettings && !profileSettingInited) {
      const ainl = userProfileSettings.find(e => e.settingCode === 'EnableAddInventoryToNewLocation');
      const enl = userProfileSettings.find(e => e.settingCode === 'EnableLOT');
      const enu = userProfileSettings.find(e => e.settingCode === 'EnableUOM');
      const mpc = userProfileSettings.find(e => e.settingCode === 'EnableMultiPurpostProductCode');

      //console.log('ainl', ainl, enl, enu);
      setProfileSettingInited(true);
      dispatch({ type: PRAction.SetLockScreen, params: false });
      ainl && setEnableAddNewLocation(ainl.settingValue === '1');
      //enl && setLotEnable(enl.settingValue === '1');
      enl && dispatch({ type: PRAction.SetEnableLot, params: enl.settingValue === '1' });
      //enu && setUomEnable(enu.settingValue === '1');
      enu && dispatch({ type: PRAction.SetEnableUom, params: enu.settingValue === '1' });

      if (mpc) {
        dispatch({ type: PRAction.SetEnableMultiPurposeCode, params: mpc.settingValue === '1' });
        (mpc.settingValue === '1') ? openPatternCodeSelector() : onClosePatternCodeSelectorWithoutSelection();
      } else {
        //tryOpenDefaultLocationDialogWithoutPatternCode();
      }
    }
  }, [
    inited,
    profileSettingInited,
    state,
    userProfileSettings,
    warehouseList,
  ]);

  return (<>
    <SmartSpace className="mb-5">
      {currentStep === AdjustStep.ScanItem && (<>
        <SmartFormLabel
          style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
        >
          Scan Item
        </SmartFormLabel>
        <SmartScanner
          className="fs-24 mt-2 mb-5 h-50"
          //disabled={isFetching}
          key={`pc-scanner${itemCodeScannerVersion}`}
          //isAutoFocus={autoFocus}
          placeholder="Input item here"
          onChangeValue={onItemCodeChange}
        />
        <SmartBackButton
          onClick={onPageBack}
        />
      </>)}
      {currentStep === AdjustStep.ScanLocation && (<>
        <SmartFormLabel
          style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
        >
          Scan Target Location
        </SmartFormLabel>
        <SmartScanner
          className="fs-24 mt-5 mb-5 h-50"
          //disabled={isFetching}
          //key={`pc-scanner${itemCodeScannerVersion}`}
          //isAutoFocus={autoFocus}
          placeholder="Input location here"
          onChangeValue={onLocationCodeChange}
        />
        <SmartRow justify="space-between">
          <Text>
            {t('common.sku')}:
            <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
              {productLocations[0]?.sku}
            </Text>
          </Text>
          <Text>
            {t('common.upc')}:
            <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
              {productLocations[0]?.upc}
            </Text>
          </Text>
        </SmartRow>
        {isPatternCodeIncludeLotOrUomOrQty() && (
          <SmartRow justify="space-between">
            {isPatternCodeIncludeLot() && (
              <Text>
                {t('common.lotNumber')}:
                <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                  {getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT)}
                </Text>
              </Text>
            )}
            {isPatternCodeIncludeUom() && (
              <Text>
                {t('common.uom')}:
                <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                  {getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM)}
                </Text>
              </Text>
            )}
            {isPatternCodeIncludeQty() && (
              <Text>
                {t('common.qty')}:
                <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                  {getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty)}
                </Text>
              </Text>
            )}
          </SmartRow>
        )}
        <SmartRow>
          <Text strong style={{ fontSize: 16 }}>
            {t('common.location')}:
          </Text>
        </SmartRow>
        <Table
          size="small"
          rowKey={(record) =>
            `${record.locationCode}_${record.sku}_${record.lotNumber}_${record.uom}_${record.uomRate}`
          }
          bordered
          columns={getColumns()}
          dataSource={productLocations}
          //onRow={onLocationTableRow}
          pagination={false}
          style={{ marginTop: 10, marginBottom: 10 }}
        />
        <SmartBackButton
          onClick={onPageBack}
        />
      </>)}
      {currentStep === AdjustStep.ConfirmToSubmit && (<>
        <SmartRow>
          <SmartFormLabel
            style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
          >
            Adding SKU
          </SmartFormLabel>
          <Text strong className="fs-16 ml-8">
            {productLocations[0].sku}
          </Text>
        </SmartRow>
        {state.enableLot && (
          <SmartRow align="middle" className="mt-15">
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {t('common.lotNumber')}
            </SmartFormLabel>
            <SmartScannerInput
              addonAfter={searchLotButton()}
              allowClear
              className="fs-24 h-50 ml-8"
              defaultValue={adjustLotCode}
              disabled={!isLotReleased()}
              onClear={onClearLotCode}
              onScan={onScanLot}
              placeholder="Input LOT# here"
              style={{width: 'calc(100% - 110px)'}}
              version={lotScannerVersion}
            />
            {/*<SuccessButton
              className="fs-22 h-50 p-4-13"
              disabled={!isLotReleased()}
              onClick={openCreateLotDrawer}
            >
              <PlusOutlined />
            </SuccessButton>*/}
          </SmartRow>
        )}
        {state.enableUom && (
          <SmartRow align="middle" className="mt-15" justify="space-between">
            <Space>
              <SmartFormLabel
                style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
              >
                {t('common.uom')}
              </SmartFormLabel>
              <span className="fs-18 text-grey">
                {isUomEnabled() && `${state.uomInfo.uom}(${state.uomInfo.uomRate})`}
              </span>
            </Space>
            <Button
              className="fs-20 h-48 p-4-12 default-btn-info"
              disabled={!isUomEnabled()}
              onClick={openUomSelector}
            >
              <SelectOutlined />
            </Button>
          </SmartRow>
        )}
        <SmartRow align="middle" className="mt-15">
          <SmartFormLabel
            className="mr-8"
            style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
          >
            {t('common.qty')}
          </SmartFormLabel>
          <SmartNumberInput
            className="num-input h-50"
            //disabled={!isQtyChangeable()}
            //key={`recv-input${qtyInputVersion}`}
            min={0}
            onChange={onAdjustQtyChange}
            style={{width: 'calc(100% - 173px)'}}
            value={adjustQty}
          />
        </SmartRow>
        <SmartRow align="middle" className="mt-15">
          <SmartFormLabel
            style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
          >
            Target Location
          </SmartFormLabel>
          <Text strong className="fs-16 ml-8">
            {targetLocation.locationCode}
          </Text>
        </SmartRow>
        <SmartRow className="mt-15" justify="center">
          <SmartButton
            disabled={!isAdjustable()}
            onClick={adjustProduct}
            type="primary"
          >
            Confirm
          </SmartButton>
        </SmartRow>
        <SmartBackButton
          onClick={onPageBack}
        />
      </>)}
    </SmartSpace>
    {defaultWarehouseVisible && (
      <SetDefaultWarehouseDialog
        closable={dialogClosable}
        close={() => {
          setDefaultWarehouseVisible(false);
        }}
        visible={defaultWarehouseVisible}
      />
    )}
    {patternCodeSelectorVisible && (
      <PatternCodeSelector
        dispatch={dispatch}
        maskClosable={false}
        onCancel={closePatternCodeSelector}
        onClosePatternCodeSelectorWithoutSelection={onClosePatternCodeSelectorWithoutSelection}
        onSelectPatternCode={onSelectPatternCode}
        state={state}
        title="Select Pattern Code"
        visible={patternCodeSelectorVisible}
      />
    )}
    {isSearchLotDrawerOpen && (
      <SearchLotDrawer
        dispatch={dispatch}
        onClose={closeSearchLotDrawer}
        onSelect={onSelectLot}
        state={state}
        sku={productLocations[0].sku}
        visible={isSearchLotDrawerOpen}
      />
    )}
    {uomSelectorVisible && (
      <UomSelector
        bodyStyle={{padding: 10}}
        dispatch={dispatch}
        onCancel={closeUomSelector}
        onSelectUom={onSelectUom}
        refInfo={productLocations[0]}
        state={state}
        title="Select UOM"
        visible={uomSelectorVisible}
      />
    )}
    {state.lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default GuidedAdjust;
